<template>
  <div class="led_box animate__animated animate__fadeIn">
    <div class="led">
      <!-- 环境监测详情 -->
      <div class="content_box">
        <div class="content_title">
          <div class="search-btn orange" style="float: right;margin: 12px 50px 0 0;width: 200px" @click="fnUpload"><span>上传至重庆市建委平台</span></div>
        </div>
        <div class="content">
          <div class="content_tab">
            <el-tabs v-model="activeName" type="border-card">
              <el-tab-pane label="环境监测设备定位数据" name="environment_location">
                <div class="location"><a href="https://lbs.amap.com/console/show/picker" target="_blank">点击拾取坐标</a></div>
                <sTabPane :data="environment_location" :dataConfig="environment_locationConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="塔吊监测基础信息" name="tower_crane_basic">
                <sTabPane :data="tower_crane_basic" :dataConfig="tower_crane_basicConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="塔吊司机身份识别数据" name="tower_crane_driverIdentity">
                <sTabPane :data="tower_crane_driverIdentity" :dataConfig="tower_crane_driverIdentityConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="塔吊监测定位数据" name="tower_crane_location">
                <div class="location"><a href="https://lbs.amap.com/console/show/picker" target="_blank">点击拾取坐标</a></div>
                <sTabPane :data="tower_crane_location" :dataConfig="tower_crane_locationConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="塔吊攀爬防护基础信息" name="climbing_tower_crane">
                <div class="location"><a href="https://lbs.amap.com/console/show/picker" target="_blank">点击拾取坐标</a></div>
                <sTabPane :data="climbing_tower_crane" :dataConfig="climbing_tower_craneConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="附着式升降脚手架基础信息" name="smart_climb">
                <div class="location"><a href="https://lbs.amap.com/console/show/picker" target="_blank">点击拾取坐标</a></div>
                <sTabPane :data="smart_climb" :dataConfig="smart_climbConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="升降机监测基础信息" name="elevator_basic"><sTabPane :data="elevator_basic" :dataConfig="elevator_basicConfig.config"></sTabPane></el-tab-pane>
              <el-tab-pane label="升降机司机身份识别数据" name="elevator_driverIdentity">
                <sTabPane :data="elevator_driverIdentity" :dataConfig="elevator_driverIdentityConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="升降机监测定位数据" name="elevator_location">
                <div class="location"><a href="https://lbs.amap.com/console/show/picker" target="_blank">点击拾取坐标</a></div>
                <sTabPane :data="elevator_location" :dataConfig="elevator_locationConfig.config"></sTabPane>
              </el-tab-pane>
              <el-tab-pane label="卸料平台监测基础信息" name="unloading_platform_basic">
                <sTabPane :data="unloading_platform_basic" :dataConfig="unloading_platform_basicConfig.config"></sTabPane>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog_choose" v-if="showUpload">
      <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="上传进度" top="20vh" center :visible.sync="showUpload" @close="fnUploadFinish">
        <div class="line_item">
          <span>上传中：{{ uploading }};</span>
          <span>上传成功：{{ upload_successful }};</span>
          <span>上传失败：{{ upload_failure }}。</span>
        </div>
        <div class="cont_list">
          <div class="list_title">
            <div class="title_item">上传名称</div>
            <div class="title_item">状态</div>
            <div class="title_item">详情</div>
          </div>
          <div class="list_boxes">
            <div class="list_box">
              <div class="box_line" v-for="(item, index) in uploadList" :key="index">
                <div class="list_item">{{ item.name }}</div>
                <div class="list_item">
                  <span v-if="item.result == 1">上传中</span>
                  <span v-else-if="item.result == 2">上传成功</span>
                  <span v-else style="color: #C03639">上传失败</span>
                </div>
                <p class="list_item" :title="item.details" style="overflow:hidden; white-space:nowrap; justify-content: normal;">{{ item.details }}</p>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" align="center">
          <div class="btn_line">
            <div class="search-btn" @click="fnUploadFinish"><span>确定</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import sTabPane from '@/components/s-tab-pane';
import { fnRequestPlatform } from '@/utils/upload';
export default {
  components: {
    sTabPane
  },
  data() {
    let baseRadio = { 0: '未配置', 1: '已配置' }; // 默认单选配置
    return {
      activeName: 'environment_location', // 默认选中tab
      editId: '', // 编辑id

      environment_location: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          Latitude: '106.544691', // 纬度
          Longitude: '29.401571' // 经度
        }
      ], // 环境监测设备定位数据
      environment_locationConfig: {
        name: '环境监测设备定位数据',
        url: 'EnvironmentLocation',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          Latitude: { type: 0, name: '纬度', parameter: '请输入纬度' }, // 纬度
          Longitude: { type: 0, name: '经度', parameter: '请输入经度' } // 经度
        } // type 0输入框 1单选 2下拉
      },

      tower_crane_basic: [
        {
          DeviceFactory: '中公智联', // C2 是 设备供应商
          DeviceSN: '', // C50 是 设备序列号
          SimCardNo: '', // C11 是 SIM卡号
          SelfCraneNo: '', // N2 是 塔机名称和编号1~16
          CraneType: '', // C1  塔机类 ,0: 动臂吊 ,1: 塔头平臂吊 ,2: 平头平臂吊
          WeightSet: '1', // C1 是 配置载重功能 ,0:未配置 ,1:已配
          WindSpeedSet: '1', // C1 是 配置风速功能 ,0:未配置 ,1:配置
          RangeSet: '1', // C1 是 配置幅度功能 ,0:未配置1:已配
          HeightSet: '1', // C1 是 配置高度功能 ,0:未配置 ,1:已配置
          AngleSet: '1', // C1 是 配置角度功能 ,0:未配置 ,1:已配置
          ObliguitySet: '1', // C1 是 配置倾角功能 ,0:未配置 ,1:已配置
          GpsSet: '1', // C1 是 配GPS功能 ,0:未配置 ,1:已配置
          IdSet: '1', // C1 是 配置人员识别功能
          FrontArmLength: '', // N5.2 是 前臂长0.00~99.99m
          BackArmLength: '', // N5.2 是 尾臂长0.0~99.99m
          MaxWeight: '', // N5.2 是 最大吊重 ,000~99.99t
          RatedWindSpeed: '', // N5.2 是 额定风速 ,0.00~36.90m/s
          RatedWindLevel: '', // N2 是 额定风级 ,0~12级
          MinRange: '', // N5.2 是 最小变幅 ,0.00~99.99m
          MaxRange: '', // N.2 是 最大变幅 ,0.00~99.99m
          ArmHeight: '', // N.2 是 最大臂高 ,0.00~655.35m
          MaxHeight: '', // N6.2 是 最大高度 ,0.00~655.35m
          MaxAngle: '', // N6.1 是 最大角度 ,540.0°
          MinAngle: '', // N6.1 是 最小角度 ,-540.0°
          RatedObliguity: '', // N4.2 是 额定倾角 ,0.00~9.99°
          TC_MS_LoadCapacity: '', // N5.2 是 最大幅度允许最大载重0.00~99.99t
          TC_ML_MaxScope: '', // N6.2 是 最大载重达到最大幅度0.00~655.3m
          DifferInput: '', // N1 是 载重滤波等级 1~9
          SettingMinHeight: '', // N6.1 是 高度报警阈值 0.00~655.3m
          WeightZero: '', // N5.2 是 载重零点值 0.00~99.99t
          WindSpeedZero: '', // N5.2 是 风速零点值 0.00~99.99m/s
          AngleZero: '', // N5.1 是 角度零点值 0.0~359.9°
          DipXZero: '', // N4.2 是 倾角X零点值 0.00~9.99°
          DipYZero: '', // N4.2 是 倾角Y零点值 0.00~9.99°
          ElevationAngleZero: '', // N5.2 是 动臂吊仰角零点值 0.00~99.99°
          ForbidEntryFunExist: '0', // C1 是 配置禁入区功能
          ForbidEntryExist: '0', // C1 是 禁入区域是否存在
          ForbidEntryAngle0: '', // N.1 否 禁入区域角度10.0~359.9°
          ForbidEntryAngle1: '' // N5.1 否 禁入区域角度20.0~359.9°
        }
      ], // 塔吊监测基础信息
      tower_crane_basicConfig: {
        name: '塔吊监测基础信息',
        url: 'TowerCraneBasic',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          SimCardNo: { type: 0, name: 'SIM卡号', parameter: '请输入SIM卡号' }, // C11 是 SIM卡号
          SelfCraneNo: { type: 0, name: '塔机名称和编号', parameter: '请输入塔机名称和编号:1~16' }, // N2 是 塔机名称和编号1~16
          CraneType: { type: 2, name: '塔机类型', parameter: { 0: '动臂吊', 1: '塔头平臂吊', 2: '平头平臂吊' } }, // C1  塔机类 ,0: 动臂吊 ,1: 塔头平臂吊 ,2: 平头平臂吊
          WeightSet: { type: 1, name: '配置载重功能', parameter: baseRadio }, // C1 是 配置载重功能 ,0:未配置 ,1:已配
          WindSpeedSet: { type: 1, name: '配置风速功能', parameter: baseRadio }, // C1 是 配置风速功能 ,0:未配置 ,1:配置
          RangeSet: { type: 1, name: '配置幅度功能', parameter: baseRadio }, // C1 是 配置幅度功能 ,0:未配置1:已配
          HeightSet: { type: 1, name: '配置高度功能', parameter: baseRadio }, // C1 是 配置高度功能 ,0:未配置 ,1:已配置
          AngleSet: { type: 1, name: '配置角度功能', parameter: baseRadio }, // C1 是 配置角度功能 ,0:未配置 ,1:已配置
          ObliguitySet: { type: 1, name: '配置倾角功能', parameter: baseRadio }, // C1 是 配置倾角功能 ,0:未配置 ,1:已配置
          GpsSet: { type: 1, name: '配GPS功能', parameter: baseRadio }, // C1 是 配GPS功能 ,0:未配置 ,1:已配置
          IdSet: { type: 1, name: '配置人员识别功能', parameter: baseRadio }, // C1 是 配置人员识别功能
          FrontArmLength: { type: 0, name: '前臂长', parameter: '限制区间 0~99.99m' }, // N5.2 是 前臂长0.00~99.99m
          BackArmLength: { type: 0, name: '尾臂长', parameter: '限制区间 0~99.99m' }, // N5.2 是 尾臂长0.0~99.99m
          MaxWeight: { type: 0, name: '最大吊重', parameter: '限制区间 0~99.99t' }, // N5.2 是 最大吊重 ,000~99.99t
          RatedWindSpeed: { type: 0, name: '额定风速', parameter: '限制区间 0.00~36.90m/s' }, // N5.2 是 额定风速 ,0.00~36.90m/s
          RatedWindLevel: { type: 0, name: '额定风级', parameter: '限制区间 0~12级' }, // N2 是 额定风级 ,0~12级
          MinRange: { type: 0, name: '最小变幅', parameter: '限制区间 0.00~99.99m' }, // N5.2 是 最小变幅 ,0.00~99.99m
          MaxRange: { type: 0, name: '最大变幅', parameter: '限制区间 0.00~99.99m' }, // N.2 是 最大变幅 ,0.00~99.99m
          ArmHeight: { type: 0, name: '最大臂高', parameter: '限制区间 0.00~655.35m' }, // N.2 是 最大臂高 ,0.00~655.35m
          MaxHeight: { type: 0, name: '最大高度', parameter: '限制区间 0.00~655.35m' }, // N6.2 是 最大高度 ,0.00~655.35m
          MaxAngle: { type: 0, name: '最大角度', parameter: '限制区间 540.0°' }, // N6.1 是 最大角度 ,540.0°
          MinAngle: { type: 0, name: '最小角度', parameter: '限制区间 -540.0°' }, // N6.1 是 最小角度 ,-540.0°
          RatedObliguity: { type: 0, name: '额定倾角', parameter: '限制区间 0.00~9.99°' }, // N4.2 是 额定倾角 ,0.00~9.99°
          TC_MS_LoadCapacity: { type: 0, name: '最大幅度允许最大载重', parameter: '限制区间 0.00~99.99t' }, // N5.2 是 最大幅度允许最大载重0.00~99.99t
          TC_ML_MaxScope: { type: 0, name: '最大载重达到最大幅度', parameter: '限制区间 0.00~655.3m' }, // N6.2 是 最大载重达到最大幅度0.00~655.3m
          DifferInput: { type: 0, name: '载重滤波等级', parameter: '限制区间 1~9' }, // N1 是 载重滤波等级 1~9
          SettingMinHeight: { type: 0, name: '高度报警阈值', parameter: '限制区间 0.00~655.3m' }, // N6.1 是 高度报警阈值 0.00~655.3m
          WeightZero: { type: 0, name: '载重零点值', parameter: '限制区间 0.00~99.99t' }, // N5.2 是 载重零点值 0.00~99.99t
          WindSpeedZero: { type: 0, name: '风速零点值', parameter: '限制区间 0.00~99.99m/s' }, // N5.2 是 风速零点值 0.00~99.99m/s
          AngleZero: { type: 0, name: '角度零点值', parameter: '限制区间 0.0~359.9°' }, // N5.1 是 角度零点值 0.0~359.9°
          DipXZero: { type: 0, name: '倾角X零点值', parameter: '限制区间 0.00~9.99°' }, // N4.2 是 倾角X零点值 0.00~9.99°
          DipYZero: { type: 0, name: '倾角Y零点值', parameter: '限制区间 0.00~9.99°' }, // N4.2 是 倾角Y零点值 0.00~9.99°
          ElevationAngleZero: { type: 0, name: '动臂吊仰角零点值', parameter: '限制区间 0.00~99.99°' }, // N5.2 是 动臂吊仰角零点值 0.00~99.99°
          ForbidEntryFunExist: { type: 1, name: '配置禁入区功能', parameter: baseRadio }, // C1 是 配置禁入区功能
          ForbidEntryExist: { type: 1, name: '禁入区域是否存在', parameter: { 0: '不存在', 1: '存在' } }, // C1 是 禁入区域是否存在
          ForbidEntryAngle0: { type: 0, name: '禁入区域角度0', parameter: '限制区间 10.0~359.9°', isNotMust: true }, // N.1 否 禁入区域角度10.0~359.9°
          ForbidEntryAngle1: { type: 0, name: '禁入区域角度1', parameter: '限制区间 20.0~359.9°', isNotMust: true } // N5.1 否 禁入区域角度20.0~359.9°
        } // type 0输入框 1单选 2下拉
      },

      tower_crane_driverIdentity: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          IdCardNumber: '', // 身份证号
          IdCardInfo: '' // 身份信息
        }
      ], // 塔吊司机身份识别数据
      tower_crane_driverIdentityConfig: {
        name: '塔吊司机身份识别数据',
        url: 'TowerCraneDriverIdentity',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' },
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' },
          IdCardNumber: { type: 0, name: '身份证号', parameter: '请输入身份证号' },
          IdCardInfo: {
            type: 2,
            name: '身份信息',
            parameter: {
              0: '未知人',
              1: '塔机司机',
              2: '检测人员',
              3: '安拆人员',
              4: '维保人员',
              5: '塔机信号工',
              6: '监理人员',
              7: '项目经理',
              8: '安全员',
              9: '其他预留'
            }
          }
        }
      },

      tower_crane_location: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          Latitude: '106.544691', // 纬度
          Longitude: '29.401571' // 经度
        }
      ], // 塔吊监测定位数据
      tower_crane_locationConfig: {
        name: '塔吊监测定位数据',
        url: 'TowerCraneLocation',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          Latitude: { type: 0, name: '纬度', parameter: '请输入纬度' }, // 纬度
          Longitude: { type: 0, name: '经度', parameter: '请输入经度' } // 经度
        }
      },

      climbing_tower_crane: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          driverId: '', // C50 是 操作员身份证号
          driverLicence: '', // C50 否 操作证书编号
          driverName: '', // C50 是 操作员姓名
          acpower: '', // C50 是 交流电源电压，单位 V
          acalarm: '0', // C1 是 交流电状态 0:正常,1:警告
          dcpower: '', // C50 是 直流电源电压，单位 V
          dcalarm: '0', // C1 是 直流电状态 0:正常,1:警告
          remainpower: '', // C50 是 剩余电量，百分比(74.5意思是74.5%)
          state: '0', // C1 是 设备状态 0:空载,1:正常载人,2:过载
          speed: '', // C50 是 速度，单位 m/s
          pull: '', // C50 是 钢绳对人拉力（攀爬助力）
          height: '', // C50 是 攀爬高度
          dayload: '', // C50 是 当天负载运行次数
          dayoverload: '', // C50 是 当天过载次数
          daycharge: '', // C50 是 当天充电次数
          daybatalarm: '', // C50 是 当天电池告警次数
          Latitude: '', // N4.2 是 经度
          Longitude: '', // N4.2 是 纬度
          speel: '1' // C1 是 在离岗标识 0:开始,1:结束
        }
      ], // 塔吊攀爬防护基础信息
      climbing_tower_craneConfig: {
        name: '塔吊攀爬防护基础信息',
        url: 'ClimbingTowerCrane',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          driverId: { type: 0, name: '操作员身份证号', parameter: '请输入操作员身份证号' }, // C50 是 操作员身份证号
          driverLicence: { type: 0, name: '操作证书编号', parameter: '请输入操作证书编号' }, // C50 否 操作证书编号
          driverName: { type: 0, name: '操作员姓名', parameter: '请输入操作员姓名' }, // C50 是 操作员姓名
          acpower: { type: 0, name: '交流电源电压', parameter: '请输入交流电源电压，单位 V' }, // C50 是 交流电源电压，单位 V
          acalarm: { type: 1, name: '交流电状态', parameter: { 0: '正常', 1: '警告' } }, // C1 是 交流电状态 0:正常,1:警告
          dcpower: { type: 0, name: '直流电源电压', parameter: '请输入直流电源电压，单位 V' }, // C50 是 直流电源电压，单位 V
          dcalarm: { type: 1, name: '直流电状态', parameter: { 0: '正常', 1: '警告' } }, // C1 是 直流电状态 0:正常,1:警告
          remainpower: { type: 0, name: '剩余电量', parameter: '请输入剩余电量，百分比' }, // C50 是 剩余电量，百分比(74.5意思是74.5%)
          state: { type: 2, name: '设备状态', parameter: { 0: '空载', 1: '正常载人', 2: '过载' } }, // C1 是 设备状态 0:空载,1:正常载人,2:过载
          speed: { type: 0, name: '速度', parameter: '请输入速度，单位 m/s' }, // C50 是 速度，单位 m/s
          pull: { type: 0, name: '钢绳对人拉力', parameter: '请输入钢绳对人拉力' }, // C50 是 钢绳对人拉力（攀爬助力）
          height: { type: 0, name: '攀爬高度', parameter: '请输入攀爬高度' }, // C50 是 攀爬高度
          dayload: { type: 0, name: '当天负载运行次数', parameter: '请输入' }, // C50 是 当天负载运行次数
          dayoverload: { type: 0, name: '当天过载次数', parameter: '请输入' }, // C50 是 当天过载次数
          daycharge: { type: 0, name: '当天充电次数', parameter: '请输入' }, // C50 是 当天充电次数
          daybatalarm: { type: 0, name: '当天电池告警次数', parameter: '请输入' }, // C50 是 当天电池告警次数
          Latitude: { type: 0, name: '经度', parameter: '请输入经度' }, // N4.2 是 经度
          Longitude: { type: 0, name: '纬度', parameter: '请输入经度' }, // N4.2 是 纬度
          speel: { type: 1, name: '在离岗标识', parameter: { 0: '开始', 1: '结束' } } // C1 是 在离岗标识 0:开始,1:结束
        }
      },

      smart_climb: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          driverId: '', // C50 是 操作员身份证号
          driverLicence: '', // C50 否 操作员证书编号
          driverName: '', // C50  操作员姓名
          weight: '', // N.2 是 重量
          Latitude: '', // N18.2 是 经度
          Longitude: '', // N18.2 是 纬度
          status: '', // C1 是 状态 0:正常,1:失载,2:超载,3:失载预警,4:超载预警
          message: '' // C50 是 预警/报警/违章消息，非正常状态时必须传入
        }
      ], // 附着式升降脚手架基础信息
      smart_climbConfig: {
        name: '附着式升降脚手架基础信息',
        url: 'SmartClimb',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          driverId: { type: 0, name: '操作员身份证号', parameter: '请输入' }, // C50 是 操作员身份证号
          driverLicence: { type: 0, name: '操作员证书编号', parameter: '请输入' }, // C50 否 操作员证书编号
          driverName: { type: 0, name: '操作员姓名', parameter: '请输入' }, // C50  操作员姓名
          weight: { type: 0, name: '重量', parameter: '请输入' }, // N.2 是 重量
          Latitude: { type: 0, name: '经度', parameter: '请输入' }, // N18.2 是 经度
          Longitude: { type: 0, name: '经度', parameter: '请输入' }, // N18.2 是 纬度
          status: { type: 2, name: '状态', parameter: { 0: '正常', 1: '失载', 2: '超载', 3: '失载预警', 4: '超载预警' } }, // C1 是 状态 0:正常,1:失载,2:超载,3:失载预警,4:超载预警
          message: { type: 0, name: '经度', parameter: '请输入' } // C50 是 预警/报警/违章消息，非正常状态时必须传入
        }
      },

      elevator_basic: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          SimCardNo: '', // C11 是 SIM卡号
          CraneType: '2', // C1 是 升机类型 1: 单笼,2: 双笼
          IdExist: '1', // C1 是 配置工号识别功能 0:未置,1:已配置
          PeopleExist: '1', // C1 是 配置人数检测功能 0:未配置,:已配置
          WeightExist: '1', // C1 是 配置载重功能 0:未置,1:已配置
          SpeedExist: '1', // C1 是 配置速度检测功能 0未配置,1:已配置
          HeightExist: '1', // C1 是 配置高度检测功能 :未配置,1:已配置
          FloorExist: '1', // C1 是 配置楼层功能 0:未配置1:已配置
          ObliguityXExist: '1', // C1 是 配置X轴倾角功能 0:未配,1:已配置
          ObliguityYExist: '1', // C1 是 配置Y轴倾角能 0:未配置,1:已配置
          WindExist: '1', // C1 是 配置风速功能 0:未配置,1:已配置
          GpsExist: '1', // C1 是 配置GPS定位功能 0:未配置,1:已配置
          WirelessExist: '1', // C1 是 配置无线功能 0:未配置,1:已配置
          TopExist: '1', // C1 是 配置上下限位(冲顶)检测功能 0:未配置,1:已配置
          AntiDropExist: '1', // C1 是 配置防坠器在位检测功能 0:未配置,1:已配置
          OutDoorStatus: '1', // C1 是 外笼门状态 0:打开,1:关闭
          RatedPeople: '', // N2 是 额定运载人数 1-20人
          RatedWeight: '', // N4.2 是 额定载重 0.00~9.99t
          RatedUpSpeed: '', // N4.2 是 额定上行速度 0.00~9.99m/s
          RatedDownSpeed: '', // N4.2 是 额定下行速度 0.00~9.99m/s
          RatedHeight: '', // N5.1 是 额定高度 0.0~999.9m
          MaxFloor: '', // N3 是 最大楼层 0~100层
          MinFloor: '', // N2 是 最小楼层 0~ -3层
          RatedObliguityX: '', // N4.2 是 额定X轴倾角 0.00~9.99°
          RatedObliguityY: '', // N4.2 是 额定Y轴倾角 0.00~9.99°
          RatedWindSpeed: '', // N5.2 是 额定风速 0.00~36.90m/s
          RatedWindLevel: '' // N2 是 额定风级 0~12级
        }
      ], // 升降机监测基础信息
      elevator_basicConfig: {
        name: '升降机监测基础信息',
        url: 'ElevatorBasic',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          SimCardNo: { type: 0, name: 'SIM卡号', parameter: '请输入' }, // C11 是 SIM卡号
          CraneType: { type: 1, name: '升机类型', parameter: { 0: '单笼', 1: '双笼' } }, // C1 是 升机类型 1: 单笼,2: 双笼
          IdExist: { type: 1, name: '配置工号识别功能', parameter: baseRadio }, // C1 是 配置工号识别功能 0:未置,1:已配置
          PeopleExist: { type: 1, name: '配置人数检测功能', parameter: baseRadio }, // C1 是 配置人数检测功能 0:未配置,:已配置
          WeightExist: { type: 1, name: '配置载重功能', parameter: baseRadio }, // C1 是 配置载重功能 0:未置,1:已配置
          SpeedExist: { type: 1, name: '配置速度检测功能', parameter: baseRadio }, // C1 是 配置速度检测功能 0未配置,1:已配置
          HeightExist: { type: 1, name: '配置高度检测功能', parameter: baseRadio }, // C1 是 配置高度检测功能 :未配置,1:已配置
          FloorExist: { type: 1, name: '配置楼层功能', parameter: baseRadio }, // C1 是 配置楼层功能 0:未配置1:已配置
          ObliguityXExist: { type: 1, name: '配置X轴倾角功能', parameter: baseRadio }, // C1 是 配置X轴倾角功能 0:未配,1:已配置
          ObliguityYExist: { type: 1, name: '配置Y轴倾角能', parameter: baseRadio }, // C1 是 配置Y轴倾角能 0:未配置,1:已配置
          WindExist: { type: 1, name: '配置风速功能', parameter: baseRadio }, // C1 是 配置风速功能 0:未配置,1:已配置
          GpsExist: { type: 1, name: '配置GPS定位功能', parameter: baseRadio }, // C1 是 配置GPS定位功能 0:未配置,1:已配置
          WirelessExist: { type: 1, name: '配置无线功能', parameter: baseRadio }, // C1 是 配置无线功能 0:未配置,1:已配置
          TopExist: { type: 1, name: '配置上下限位(冲顶)检测功能', parameter: baseRadio }, // C1 是 配置上下限位(冲顶)检测功能 0:未配置,1:已配置
          AntiDropExist: { type: 1, name: '配置防坠器在位检测功能', parameter: baseRadio }, // C1 是 配置防坠器在位检测功能 0:未配置,1:已配置
          OutDoorStatus: { type: 1, name: '外笼门状态', parameter: { 0: '打开', 1: '关闭' } }, // C1 是 外笼门状态 0:打开,1:关闭
          RatedPeople: { type: 0, name: '额定运载人数', parameter: '限制区间 1-20人' }, // N2 是 额定运载人数 1-20人
          RatedWeight: { type: 0, name: '额定载重', parameter: '限制区间 0.00~9.99t' }, // N4.2 是 额定载重 0.00~9.99t
          RatedUpSpeed: { type: 0, name: '额定上行速度', parameter: '限制区间 0.00~9.99m/s' }, // N4.2 是 额定上行速度 0.00~9.99m/s
          RatedDownSpeed: { type: 0, name: '额定下行速度', parameter: '限制区间 0.00~9.99m/s' }, // N4.2 是 额定下行速度 0.00~9.99m/s
          RatedHeight: { type: 0, name: '额定高度', parameter: '限制区间 0.0~999.9m' }, // N5.1 是 额定高度 0.0~999.9m
          MaxFloor: { type: 0, name: '最大楼层', parameter: '限制区间 0~100层' }, // N3 是 最大楼层 0~100层
          MinFloor: { type: 0, name: '最小楼层', parameter: '限制区间 0~-3层' }, // N2 是 最小楼层 0~ -3层
          RatedObliguityX: { type: 0, name: '额定X轴倾角', parameter: '限制区间 0.00~9.99°' }, // N4.2 是 额定X轴倾角 0.00~9.99°
          RatedObliguityY: { type: 0, name: '额定Y轴倾角', parameter: '限制区间 0.00~9.99°' }, // N4.2 是 额定Y轴倾角 0.00~9.99°
          RatedWindSpeed: { type: 0, name: '额定风速', parameter: '限制区间 0.00~36.90m/s' }, // N5.2 是 额定风速 0.00~36.90m/s
          RatedWindLevel: { type: 0, name: '额定风级', parameter: '限制区间 0~12级' } // N2 是 额定风级 0~12级
        }
      },

      elevator_driverIdentity: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          Name: '', // 司机姓名
          IdCardNumber: '', // 身份证号
          IdCardInfo: '' // 身份信息
        }
      ], // 升降机司机身份识别数据
      elevator_driverIdentityConfig: {
        name: '升降机司机身份识别数据',
        url: 'ElevatorDriverIdentity',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' },
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' },
          Name: { type: 0, name: '司机姓名', parameter: '请输入司机姓名' },
          IdCardNumber: { type: 0, name: '身份证号', parameter: '请输入身份证号' },
          IdCardInfo: {
            type: 2,
            name: '身份信息',
            parameter: {
              0: '未知人',
              1: '塔机司机',
              2: '检测人员',
              3: '安拆人员',
              4: '维保人员',
              5: '塔机信号工',
              6: '监理人员',
              7: '项目经理',
              8: '安全员',
              9: '其他预留'
            }
          }
        }
      },

      elevator_location: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          Latitude: '106.544691', // 纬度
          Longitude: '29.401571' // 经度
        }
      ], // 升降机监测定位数据
      elevator_locationConfig: {
        name: '升降机监测定位数据',
        url: 'ElevatorLocation',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          Latitude: { type: 0, name: '纬度', parameter: '请输入纬度' }, // 纬度
          Longitude: { type: 0, name: '经度', parameter: '请输入经度' } // 经度
        }
      },

      unloading_platform_basic: [
        {
          DeviceFactory: '中公智联', // 设备供应商
          DeviceSN: '', // 设备序列号
          state: '0', // C1 是 卸料平台类型0：正常，1：超重 (若不传相关参数，则系统会默认为0)
          load: '', // C10 是 载重预警阈值
          remainBattery: '', // C10 是 电池电量预警阈值%
          loadWarn: '', // C10 是 载重报警阈值
          remainBatteryWarn: '', // C10 是 电池电量报警阈值%
          dipXWarn: '', // N4.2 否 倾角X预警阈值
          dipYWarn: '', // N4.2 否 倾角Y预警阈值
          dipXAlarm: '', // N4.2 否 倾角X报警阈值
          dipYAlarm: '' // N4.2 否 倾角Y报警阈值
        }
      ], // 卸料平台监测基础信息
      unloading_platform_basicConfig: {
        name: '卸料平台监测基础信息',
        url: 'UnloadingPlatformBasic',
        config: {
          DeviceFactory: { type: 0, name: '设备供应商', parameter: '请输入设备供应商名称' }, // C2 是 设备供应商
          DeviceSN: { type: 0, name: '设备序列号', parameter: '请输入设备序列号' }, // C50 是 设备序列号
          state: { type: 1, name: '卸料平台类型', parameter: { 0: '正常', 1: '超重' } }, // C1 是 卸料平台类型0：正常，1：超重 (若不传相关参数，则系统会默认为0)
          load: { type: 0, name: '载重预警阈值', parameter: '请输入' }, // C10 是 载重预警阈值
          remainBattery: { type: 0, name: '电池电量预警阈值', parameter: '请输入' }, // C10 是 电池电量预警阈值%
          loadWarn: { type: 0, name: '载重报警阈值', parameter: '请输入' }, // C10 是 载重报警阈值
          remainBatteryWarn: { type: 0, name: '电池电量报警阈值', parameter: '请输入' }, // C10 是 电池电量报警阈值%
          dipXWarn: { type: 0, name: '倾角X预警阈值', parameter: '请输入' }, // N4.2 否 倾角X预警阈值
          dipYWarn: { type: 0, name: '倾角Y预警阈值', parameter: '请输入' }, // N4.2 否 倾角Y预警阈值
          dipXAlarm: { type: 0, name: '倾角X报警阈值', parameter: '请输入' }, // N4.2 否 倾角X报警阈值
          dipYAlarm: { type: 0, name: '倾角Y报警阈值', parameter: '请输入' } // N4.2 否 倾角Y报警阈值
        }
      },

      uploadList: {}, // 上传列表
      showUpload: false, // 上传列表弹窗开关
      uploading: 0, // 正在上传数量
      upload_successful: 0, // 上传成功数量
      upload_failure: 0 // 上传失败数量
    };
  },
  created() {
    this.fnGetExtendInfo();
  },
  methods: {
    // 获取重庆市建委3.0项目扩展信息
    fnGetExtendInfo() {
      request({
        url: 'project/getAllRegionExtend?region=cq3',
        method: 'GET'
      })
        .then(res => {
            console.log(res.data.length)
          if (res.data.length <= 0) return;

          let data = res.data[0];
          this.editId = data.id;
          this.environment_location = data.environment_location ? JSON.parse(data.environment_location) : this.environment_location;
          this.tower_crane_basic = data.tower_crane_basic ? JSON.parse(data.tower_crane_basic) : this.tower_crane_basic;
          this.tower_crane_driverIdentity = data.tower_crane_driverIdentity ? JSON.parse(data.tower_crane_driverIdentity) : this.tower_crane_driverIdentity;
          this.tower_crane_location = data.tower_crane_location ? JSON.parse(data.tower_crane_location) : this.tower_crane_location;
          this.climbing_tower_crane = data.climbing_tower_crane ? JSON.parse(data.climbing_tower_crane) : this.climbing_tower_crane;
          this.smart_climb = data.smart_climb ? JSON.parse(data.smart_climb) : this.smart_climb;
          this.elevator_basic = data.elevator_basic ? JSON.parse(data.elevator_basic) : this.elevator_basic;
          this.elevator_driverIdentity = data.elevator_driverIdentity ? JSON.parse(data.elevator_driverIdentity) : this.elevator_driverIdentity;
          this.elevator_location = data.elevator_location ? JSON.parse(data.elevator_location) : this.elevator_location;
          this.unloading_platform_basic = data.unloading_platform_basic ? JSON.parse(data.unloading_platform_basic) : this.unloading_platform_basic;
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },

    // 上传市建委
    fnUpload() {
      this.$confirm('请选择上传方式', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '上传当前选项',
        cancelButtonText: '上传所有选项'
      })
        .then(() => {
          this.fnEditExtendInfo(this.activeName);
        })
        .catch(action => {
          if (action !== 'cancel') return;
          this.fnEditExtendInfo();
        });
    },

    // 保存至数据库
    fnEditExtendInfo(_type) {
      let _obj = {};
      if (_type) {
        _obj[_type] = JSON.stringify(this[_type]);
      } else {
        _obj.environment_location = JSON.stringify(this.environment_location);
        _obj.tower_crane_basic = JSON.stringify(this.tower_crane_basic);
        _obj.tower_crane_driverIdentity = JSON.stringify(this.tower_crane_driverIdentity);
        _obj.tower_crane_location = JSON.stringify(this.tower_crane_location);
        _obj.climbing_tower_crane = JSON.stringify(this.climbing_tower_crane);
        _obj.smart_climb = JSON.stringify(this.smart_climb);
        _obj.elevator_basic = JSON.stringify(this.elevator_basic);
        _obj.elevator_driverIdentity = JSON.stringify(this.elevator_driverIdentity);
        _obj.elevator_location = JSON.stringify(this.elevator_location);
        _obj.unloading_platform_basic = JSON.stringify(this.unloading_platform_basic);
      }
      // 对参数个体进行验证
      for (let _key in _obj) {
        for (let _data_key in this[_key]) {
          for (let _platform_key in this[_key][_data_key]) {
            if (!this[_key][_data_key][_platform_key] && !this[_key + 'Config'].config[_platform_key].hasOwnProperty('isNotMust')) {
              this.$message.warning(this[_key + 'Config'].name + '-' + this[_key + 'Config'].config[_platform_key].name + ' ' + '参数不能为空');
              return;
            }
          }
        }
      }

      let upload_data = JSON.parse(JSON.stringify(_obj));
      upload_data.region = 'cq3';
      if (this.editId) upload_data.id = this.editId;

      request({
        url: 'project/addAllRegionExtend',
        method: 'POST',
        data: upload_data
      })
        .then(res => {
          this.fnGetExtendInfo();
          this.$message.success(res.data);
        })
        .catch(err => {
          this.$message.error(err.data);
        });

      this.fnUploadGov(_obj);
    },

    // 上传至市建委
    fnUploadGov(_obj) {
      let elevator_driverIdentity = _obj.elevator_driverIdentity ? JSON.parse(JSON.stringify(_obj.elevator_driverIdentity)) : {}
      if(elevator_driverIdentity){
        let _elevator_driverIdentity = JSON.parse(elevator_driverIdentity)
        for(let i in _elevator_driverIdentity){
          delete _elevator_driverIdentity[i].Name
        }
        _obj.elevator_driverIdentity = JSON.stringify(_elevator_driverIdentity)
      }
      this.showUpload = true;

      for (let _key in _obj) {
        let config = this[_key + 'Config'];

        for (let _data_key in this[_key]) {
          this.uploading++;

          let list_key = _key + _data_key;
          this.uploadList[list_key] = {
            name: config.name + ' 设备-' + (Number(_data_key) + 1),
            result: 1, //1上传中，2上传成功，3上传失败
            details: ''
          };

          fnRequestPlatform(
            {
              url: '/Cq/' + config.url,
              method: 'POST',
              data: {
                carry: this[_key][_data_key]
              }
            },
            res => {
              this.uploading--;
              if (res.code === 1) {
                this.uploadList[list_key].result = 2;
                this.upload_successful++;
              } else {
                this.uploadList[list_key].details = res.data;
                this.uploadList[list_key].result = 3;
                this.upload_failure++;
              }
            }
          );
        }
      }
    },

    // 关闭上传列表弹窗
    fnUploadFinish() {
      this.showUpload = false;
      this.uploadList = {};
      this.uploading = 0;
      this.upload_successful = 0;
      this.upload_failure = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.led_box {
  width: 1920px;
  height: 858px;
  position: relative;
  overflow: hidden;
  .led {
    position: absolute;
    left: 0;
    right: -20px;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.content_box {
  position: relative;
  overflow: hidden;
  background-color: rgba(29, 68, 149, 0.1);
  width: 1880px;
  height: 848px;
  margin: 10px 0 0 20px;
  .content_title {
    width: 1880px;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    text-align: center;
  }
  .content {
    width: 1880px;
    height: 730px;
    position: relative;
    overflow: hidden;
    .content_tab {
      position: absolute;
      left: 0;
      right: -30px;
      top: 0;
      bottom: 0;
      overflow-x: hidden;
      overflow-y: auto;
      .location {
        position: absolute;
        top: 10px;
        right: 80px;
        color: #3a8ee6;
      }
      >>> .el-tabs--border-card {
        width: 1880px;
        height: 730px;
        border: none;
        background: transparent;
      }
      >>> .el-tabs--border-card > .el-tabs__header {
        background: url(../../../assets/img/per_list_bg.png) no-repeat;
        background-size: 100% 100%;
        border: none;
      }
      >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item {
        border: none !important;
      }
      >>> .el-tabs__item {
        color: rgba(255, 255, 255, 0.8);
      }
      >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
        color: #409eff;
      }
      >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
        color: #409eff;
        background-color: rgba(0, 255, 255, 0.1);
        border: none !important;
      }
      >>> .el-input {
        width: 220px;
      }
      >>> .el-input__inner {
        width: 220px;
        height: 30px;
        border-radius: 2px;
        border: none;
        color: rgb(99, 195, 255);
        background-color: rgba(49, 88, 128, 0.4);
        &::-webkit-input-placeholder {
          color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: rgba(77, 180, 244, 0.7);
        }
      }
    }
  }
  >>> .el-switch__core:after {
    content: '';
  }
}
.data_list {
  position: absolute;
  top: 0;
  left: 1620px;
  width: 300px;
  height: 848px;
  margin-top: 10px;
  background-color: rgba(29, 68, 149, 0.1);
  .title {
    width: 300px;
    height: 60px;
    font-size: 24px;
    background: url(../../../assets/img/per_list_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(center, center);
  }
  .list_title {
    width: 300px;
    height: 48px;
    background: url(../../../assets/img/enter_left_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(flex-start, center);
    .title_item {
      width: 96px;
      margin: 0 2px;
      text-align: center;
      &:nth-child(1) {
        width: 196px;
      }
    }
  }
  .list_box {
    width: 300px;
    height: 740px;
    .box_line {
      width: 300px;
      height: 48px;
      cursor: pointer;
      border-bottom: 1px dashed #1d4495;
      @include flex-box(center, center);
      &:hover {
        background-color: rgba(49, 88, 128, 0.4);
      }
      .line_item {
        width: 96px;
        margin: 0 2px;
        text-align: center;
        &:nth-child(1) {
          width: 196px;
        }
      }
    }
  }
}
.dialog_choose {
  .line_item {
    margin: 5px;
    height: 20px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.8);
  }
  .btn_line {
    @include flex-box(center, center);
  }
  >>> .el-dialog {
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
    .row-item {
      color: white;
    }
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  >>> .el-dialog {
    width: 910px;
    height: 630px;
  }
  .cont_list {
    width: 860px;
    height: 425px;
    color: #ffffff;
    font-size: 16px;
    border-radius: 10px;
    margin: 0;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
      width: 860px;
      height: 48px;
      background: url(../../../assets/img/per_list_bg.png) no-repeat;
      background-size: 100% 100%;
      @include flex-box(flex-start, center);
      .title_item {
        height: 48px;
        @include flex-box(center, center);
        &:nth-child(1) {
          width: 300px;
          margin-right: 2px;
          margin-left: 30px;
        }
        &:nth-child(2) {
          width: 190px;
          margin: 0 2px;
        }
        &:nth-child(3) {
          width: 310px;
          margin: 0 2px;
        }
        .select {
          width: 20px;
          height: 20px;
          border: 1px solid #65a6dd;
          border-radius: 2px;
          cursor: pointer;
          @include prefixCss3(transition, border-color 0.2s);
          &:hover {
            border-color: #409eff;
          }
          &.active {
            background-color: #409eff;
            border-color: #409eff;
            &::after {
              content: '';
              display: block;
              width: 100%;
              height: 100%;
              @include set-bg-img('../../../assets/images/icon-yes.png');
            }
          }
        }
      }
    }
    .list_boxes {
      width: 800px;
      height: 375px;
      margin-left: 30px;
      position: relative;
      overflow: hidden;
      .list_box {
        position: absolute;
        left: 0;
        right: -25px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        .box_line {
          width: 800px;
          height: 70px;
          margin: 5px 0 0 0px;
          border-bottom: 1px dashed #1d4495;
          @include flex-box(flex-start, center);
          &:hover {
            background-color: rgba(49, 88, 128, 0.4);
          }
          .list_item {
            height: 70px;
            text-align: center;
            @include flex-box(center, center);
            &:nth-child(1) {
              width: 300px;
              margin-right: 2px;
            }
            &:nth-child(2) {
              width: 200px;
              margin: 0 2px;
            }
            &:nth-child(3) {
              width: 300px;
              margin: 0 2px;
            }
            .select {
              width: 20px;
              height: 20px;
              border: 1px solid #65a6dd;
              border-radius: 2px;
              cursor: pointer;
              @include prefixCss3(transition, border-color 0.2s);
              &:hover {
                border-color: #409eff;
              }
              &.active {
                background-color: #409eff;
                border-color: #409eff;
                &::after {
                  content: '';
                  display: block;
                  width: 100%;
                  height: 100%;
                  @include set-bg-img('../../../assets/images/icon-yes.png');
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectExtend/projectExtendCq3/index.vue